import { formatRut } from '@src/packages/utils/hooks/useRulesByCountry/constants';

import CompanyRepository from '../repositories/CompanyRepository';

class CompanyService {
  constructor() {
    this.companyRepository = new CompanyRepository();
  }

  static factoryCompanyForm(company) {
    const data = company;

    return {
      ...data,
      identifier: data?.identifier?.replace(/[^a-zA-Z0-9]/g, ''), // Remove all non-alphanumeric characters
    };
  }

  async createCompany(data) {
    const company = CompanyService.factoryCompanyForm(data);

    return this.companyRepository.create(company);
  }

  async updateCompany(data) {
    const company = CompanyService.factoryCompanyForm(data);
    return this.companyRepository.update(company);
  }

  async deleteCompany({ organizationId, companyId }) {
    return this.companyRepository.delete({ organizationId, companyId });
  }

  async getCompany({ organizationId, companyId: id }) {
    let company = await this.companyRepository.getCompany({ organizationId, companyId: id });
    company = {
      ...company,
      identifier: formatRut(company.identifier),
    };

    return company;
  }
}
export default CompanyService;
